import React from "react";
import { Box, Typography, Grid, Button, Container } from "@mui/material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

export default function BecomeInvestorPage() {
  return (
    <Box sx={{ backgroundColor: "#f8f8f8", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="lg">
        {/* Sayfa Başlığı */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h3" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
            Nasıl Yatırımcı Olunur
          </Typography>
          <Typography variant="h6" sx={{ color: "#555", lineHeight: 1.8 }}>
            Yatırımı Kolaylaştırın - Ardventure ile Yatırımcı Olun
          </Typography>
        </Box>

        {/* Bilgilendirme Kartları */}
        <Grid container spacing={4}>
          {/* Platforma Katıl */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: 3,
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                height: "100%",
              }}
            >
              <PersonAddAltIcon sx={{ fontSize: 50, color: "#1769aa", mb: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                Platforma Katıl
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                Ardventure'a katılmak oldukça basittir. E-posta adresiniz ve cep telefonu numaranızla ücretsiz hesap oluşturun. E-Devlet doğrulamasıyla hesabınızı güvenli hale getirin.
              </Typography>
            </Box>
          </Grid>

          {/* Kolayca Yatırım Yapın */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: 3,
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                height: "100%",
              }}
            >
              <AttachMoneyIcon sx={{ fontSize: 50, color: "#1769aa", mb: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                Kolayca Yatırım Yapın
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                İlgilendiğiniz kampanyayı seçin ve 'Yatırım Yap' düğmesine tıklayın. Belirli bir yatırım tutarı seçebilir veya kendi tutarınızı belirleyebilirsiniz. Güvenle ödeme yapın.
              </Typography>
            </Box>
          </Grid>

          {/* Başarıyı Paylaşın */}
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                boxShadow: 3,
                borderRadius: 2,
                p: 4,
                textAlign: "center",
                height: "100%",
              }}
            >
              <EmojiEventsIcon sx={{ fontSize: 50, color: "#1769aa", mb: 2 }} />
              <Typography variant="h5" sx={{ fontWeight: "bold", mb: 2, color: "#1769aa" }}>
                Başarıyı Paylaşın
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8, mb: 2 }}>
                Yatırımlarınızı takip edin, projelerin büyümesine katkıda bulunun ve yatırımlarınızın getirisinin keyfini çıkarın. Başarı hikayelerine katılın.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Görsel ve Ek Bilgi */}
        <Box sx={{ mt: 8, textAlign: "left" }}>
          <Grid container spacing={4} alignItems="left">
            {/* Görsel */}
            <Grid item xs={12} md={6}>
              <img
                src="/img/angel-invest.jpeg" // Görsel yolu
                alt="Yatırımcı Olma Süreci"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </Grid>

            {/* Bilgi */}
            <Grid item xs={12} md={6} sx={{ mt: 8, textAlign: "left" }}>
              <Typography variant="h4" sx={{ fontWeight: "bold", mb: 4, color: "#1769aa" }}>
                Yatırımcı Olma Süreci
              </Typography>
              <Typography variant="body1" sx={{ color: "#555", lineHeight: 1.8 }}>
                Ardventure platformuna üye olarak kolayca yatırımcı olabilir ve yenilikçi projelerin bir parçası olabilirsiniz. Şeffaf bir süreçle, yatırımlarınızı yönetmek çok daha kolay.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  mt: 4,
                  backgroundColor: "#1769aa",
                  color: "#fff",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#145a8c",
                  },
                }}
              >
                Daha Fazla Bilgi
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
}